import { UnikoServiceTypes } from "src/app/services/payments-api.service";

export const defaultServices = [
    {
      title: 'service-1.title',
      subtitle: 'service-1.description',
      imagePath: 'assets/img/business_search.png',
      ctaTitle: 'service-1.button',
      serviceType: UnikoServiceTypes.legalReport,
      isAuctionated:false
    },
    {
      title: 'service-2.title',
      subtitle: 'service-2.description',
      imagePath: 'assets/img/service-file-property-1.png',
      ctaTitle: 'service-2.button',
      serviceType: UnikoServiceTypes.technicalReport
    },
    {
      title: 'service-3.title',
      subtitle: 'service-3.description',
      imagePath: 'assets/img/service-folder-2-1.png',
      ctaTitle: 'service-3.button',
      serviceType: UnikoServiceTypes.propertyFileConstitution
    }
  ];

  export const auctionServices = [
    {
        title: 'service-4.title',
        subtitle: 'service-4.description',
        imagePath: 'assets/img/bidding_support_service.svg',
        ctaTitle: 'service-4.button',
        serviceType: UnikoServiceTypes.biddingSupport
    },
    {
        title: 'service-3.title',
        subtitle: 'service-3.description',
        imagePath: 'assets/img/service-folder-2-1.png',
        ctaTitle: 'service-3.button',
        serviceType: UnikoServiceTypes.propertyFileConstitution
    }
  ];
  